@if(isDisabled){
<app-loader></app-loader>
}
<form name="PostingOrderForm" (ngSubmit)="PostingOrderForm.form.valid && Save()" #PostingOrderForm="ngForm">
    <div class="card">
        <div class="card-header">
            Posting Order
        </div>
        <div class="m-2 card-body">
            <div class="row mt-1">
                <div class="col-md-4 px-1">
                    <label>Posting Order No. <span class="text-danger">*</span></label>
                    <input name="PostingOrderNo" class="form-control" placeholder="" [disabled]="true"
                        [(ngModel)]="Filter.PostingOrderNo" #PostingOrderNo="ngModel" required>
                    <div class="invalid-feedback">
                        Please Generate Posting Order No.
                    </div>
                </div>

                <div class="col-md-3 px-1" style="float:left">
                    <label for="postingdate" class="for-label">Transaction Date</label>
                    <input [disabled]="true" [(ngModel)]="Filter.PostingDate" type="date" class="form-control"
                        id="postingdate" name="postingdate">
                </div>
            </div>
            <div class="row mt-1">
                <div class="col-md-4 px-1">
                    <label>Branch <span class="text-danger">*</span></label>
                    <ng-select name="Branch" placeholder="Select Branch" [items]="BranchLoad" bindLabel="BranchName"
                        bindValue="BranchMasterID" [(ngModel)]="Filter.BranchID" [disabled]="Filter.PostingOrderID > 0"
                        (change)="OnBranchChange()" required>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Branch.
                    </div>
                </div>
                <div class="col-md-4 px-1">
                    <label>Employee <span class="text-danger">*</span></label>
                    <ng-select name="Employee" placeholder="Select Employee" [items]="EmployeeLoad" bindLabel="Code"
                        bindValue="EmpMasterID" [(ngModel)]="Filter.EmployeeMasterID"
                        [disabled]="Filter.PostingOrderID > 0" (change)="GetDataOnEmployeeLoad(Filter.EmployeeMasterID)"
                        required>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Employee.
                    </div>
                </div>
                <div class="col-md-4 px-1">
                    <label>Employee Name</label>
                    <input class="form-control" name="EmployeeName" placeholder="" bindValue="EmpMasterID"
                        [(ngModel)]="Filter.EmployeeName" [disabled]="true">
                    <div class="invalid-feedback">
                        Please select Employee.
                    </div>
                </div>

                <div *ngIf="IsSubContractor" class="col-md-4 px-1">
                    <label>Vendor Name</label>
                    <input class="form-control" name="VendorName" placeholder="" [(ngModel)]="Filter.VendorName"
                        [disabled]="true">
                    <div class="invalid-feedback">
                        Please select Employee.
                    </div>
                </div>

                <div class="col-md-4 px-1">
                    <label>Customer <span class="text-danger">*</span></label>
                    <ng-select name="Customer" placeholder="Select Customer" [items]="CustomerLoad"
                        bindLabel="ClientGroupName" bindValue="ClientGroupMasterID"
                        [(ngModel)]="Filter.CustomerMasterID" (change)="ComboLoad('Site')" required>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Customer.
                    </div>
                </div>
                <div class="col-md-4 px-1">
                    <label>Location <span class="text-danger">*</span></label>
                    <ng-select name="Location" placeholder="Select Location" [items]="LocationLoad" bindLabel="SiteName"
                        bindValue="SiteMasterID" [(ngModel)]="Filter.LocationMasterID"
                        (change)="ComboLoad('Designation');LoadEmployeeDesignation()" required>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Location.
                    </div>
                </div>
                <div class="col-md-4 px-1">
                    <label>Employee Designation <span class="text-danger">*</span></label>
                    <ng-select name="EmployeeDesignation" placeholder="Select Employee Designation"
                        [items]="EmployeeDesignationLoad" bindLabel="DesignationName" (change)="ComboLoad('Duty');"
                        bindValue="DesignationMasterID" 
                        [(ngModel)]="Filter.EmployeeDesignationID" required>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Customer.
                    </div>
                </div>

                <div class="col-md-4 px-1">
                    <label>Duty <span class="text-danger">*</span></label>
                    <ng-select name="duty" placeholder="Duty" [items]="DutyLoad" bindLabel="DutyName"
                        (change)="ComboLoad('ShiftLoadBasedOnDesignationDuty');" bindValue="DutyMasterID"
                        [(ngModel)]="Filter.Duty" required>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Duty.
                    </div>
                </div>

                <div class="col-md-4 px-1">
                    <label>Shift <span class="text-danger">*</span></label>
                    <ng-select name="shift" placeholder="Shift" [items]="ShiftLoad" bindLabel="ShiftTitle"
                        bindValue="ShiftMasterID" [(ngModel)]="Filter.Shift"
                        required>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Shift.
                    </div>
                </div>

                <div class="col-md-3 px-1">
                    <label for="Effectivedate" class="for-label">Date with effect From</label>
                    <input type="date" [(ngModel)]="Filter.EffectiveDate" class="form-control" id="Effectivedate"
                        name="Effectivedate">
                    <div class="invalid-feedback">
                        Please select Effective Date.
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col">
                </div>
                <div class="col-auto">
                    <div class="col-auto">
                        <button type="button" class="btn btn-outline-primary btn-sm me-1" (click)="cancel()"
                            [disabled]="isDisabled" ngbTooltip="Cancel" container="body" placement="top">
                            Cancel
                            <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                                aria-hidden="true"></span>
                        </button>
                        <button type="submit" class="btn btn-primary btn-sm me-1"
                            [disabled]="isDisabled">
                            <i class="bi bi-save2" *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled? (Filter.PostingOrderID > 0 ? 'Update' :'Save'):'Loading...'}}
                        </button>
                        <button *ngIf="!IsSubContractor" (click)="PostingOrderPrint()" type="button" class="btn btn-primary btn-sm"
                            [disabled]="isDisabled || Filter.PostingOrderID == 0">
                            <i class="bi bi-printer" *ngIf="!isDisabled"></i>
                            {{!isDisabled ? 'Print' : 'Loading...'}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>